var map = {
	"./circle-check-regular.svg": 7789,
	"./circle-info-regular.svg": 4613,
	"./envelope-dot-regular.svg": 5404,
	"./screwdriver-wrench-regular.svg": 6218,
	"./traffic-light-regular.svg": 4984,
	"./triangle-exclamation-regular.svg": 2822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4051;